export const RATIO_16_9 = 0.5625;
export const RATIO_4_3 = 0.75;
export const RATIO_9_16 = 1.7778;
